const uploads = new Map();
let uploadCounter = 0;

const canUseObjectUrl =
  typeof URL !== "undefined" && typeof URL.createObjectURL === "function";

async function fileToDataUrl(file) {
  const arrayBuffer = await file.arrayBuffer();
  let base64String;

  if (typeof Buffer !== "undefined") {
    base64String = Buffer.from(arrayBuffer).toString("base64");
  } else {
    let binary = "";
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i += 1) {
      binary += String.fromCharCode(bytes[i]);
    }
    if (typeof btoa === "function") {
      base64String = btoa(binary);
    } else {
      throw new Error("Unable to encode file to base64");
    }
  }

  const mimeType = file.type || "application/octet-stream";
  return `data:${mimeType};base64,${base64String}`;
}

export async function uploadBackgroundImage(file) {
  if (!file) {
    throw new Error("No file provided for upload");
  }

  const id = `local-upload-${++uploadCounter}`;
  let url;
  let cleanup = () => {};

  if (canUseObjectUrl) {
    url = URL.createObjectURL(file);
    cleanup = () => {
      if (typeof URL !== "undefined" && typeof URL.revokeObjectURL === "function") {
        URL.revokeObjectURL(url);
      }
    };
  } else {
    url = await fileToDataUrl(file);
  }

  uploads.set(id, {
    url,
    filename: file.name,
    cleanup,
  });

  return {
    id,
    url,
    filename: file.name,
  };
}

export async function deleteUpload(uploadId) {
  const stored = uploads.get(uploadId);
  if (stored) {
    if (typeof stored.cleanup === "function") {
      stored.cleanup();
    }
    uploads.delete(uploadId);
  }
}
